import { BasicButton } from "@goodgamestudios/asset-globals";
import { BasicDialog, EnvGlobalsHandler } from "@goodgamestudios/core";
import { MathBase } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";
import { BasicCustomCursor } from "@goodgamestudios/core";
import { IEnvironmentGlobals } from "@goodgamestudios/core";
import { BasicToolTipManager } from "@goodgamestudios/core";
import { TextField } from "@goodgamestudios/createjs-utilities";
import { TextFieldType } from "@goodgamestudios/createjs-utilities";

import { BasicTutorialController } from "../../../basic/controller/BasicTutorialController";
import { Poker2SoundController } from "../../controller/Poker2SoundController";
import { Poker2DialogEvent } from "../../event/Poker2DialogEvent";
import { Poker2TutorialEvent } from "../../event/Poker2TutorialEvent";

import DisplayObject = createjs.DisplayObject;
import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;
import Event = createjs.Event;

export class Poker2Dialog extends BasicDialog {
    protected _isLocked: boolean = false;

    /** Indicates if the dialog could be closed by click on the semi-transparent black background (true), or not (false) **/
    public hasLightBoxBehaviour: boolean = false;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
        this.backgroundAlpha = 0.35;
        disp.addEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOver));
        disp.addEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOut));
        this.controller.addEventListener("tutorialstatechange", this.bindFunction(this.onTutorialEvent));
    }

    protected updateBackground(): void {
        if (!this.bg || !this.bg.stage) {
            return;
        }

        this.bg.graphics.clear();
        this.bg.graphics.beginFill(0x000000, 1);
        this.bg.graphics.drawRect(0,0, this.disp.stage.stageWidth, this.disp.stage.stageHeight);
        this.bg.graphics.endFill();
        this.bg.x = (-this.disp.x / this.disp.scaleX) - this.layoutManager.gameNullPoint;
        this.bg.y = (-this.disp.y / this.disp.scaleY);

        this.bg.updateBounds();
        this.bg.updateCache();
    }

    protected init(): void {
        super.init();
        (this.disp as Container).changeTextFieldCacheScale(2);
        if (this.hasLightBoxBehaviour) {
            this.bg.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickBg), false, 0, true);
        }
    }

    protected onClickBg(event: MouseEvent): void {
        this.hide();
    }

    public destroy(): void {
        super.destroy();
        this.disp.removeEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOver));
        this.disp.removeEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOut));
        if(this.bg) {
            this.bg.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickBg));
        }
        this.controller.removeEventListener("tutorialstatechange", this.bindFunction(this.onTutorialEvent));
    }

    protected removeBackground(): void {
        if (this.bg) {
            if ((this.disp as Container).contains(this.bg)) {
                (this.disp as Container).removeChild(this.bg);
            }
            this.bg.uncache();
            this.bg.removeAllEventListeners();
            this.bg = null;
        }
    }

    public lockDialog(): void {
        this._isLocked = true;
    }

    public unLockDialog(): void {
        this._isLocked = false;
    }

    protected get isLocked(): boolean {
        return this._isLocked;
    }

    protected get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }

    protected updateTextField(textField: TextField): void {
        Poker2LanguageFontManager.getInstance().changeFontByLanguage(textField);
    }

    protected onClick(event: MouseEvent): void {
        if (event.target instanceof BasicButton) {
            this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_CLICK);
        }
    }

    protected get controller(): BasicController {
        return BasicController.getInstance();
    }

    protected onMouseOver(event: MouseEvent): void {
        super.onMouseOver(event);
        this.controller.dispatchEvent(new Poker2DialogEvent("mouseondialog"));

        if (BasicToolTipManager.TOOLTIP_LABEL in event.target && event.target.toolTipText)
            this.layoutManager.tooltipManager.show(event.target.toolTipText, event.target as DisplayObject);
    }

    protected onMouseOut(event: MouseEvent): void {

        super.onMouseOut(event);

        if (BasicToolTipManager.TOOLTIP_LABEL in event.target)
            this.layoutManager.tooltipManager.hide();
    }

    protected onCursorOver(event: MouseEvent): void {
        if (event.target instanceof BasicButton)
            if (event.target.enabled)
                this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);

    }

    public onResize(event: Event): void {
        super.onResize(event);
        this.updatePosition();
    }

    protected onCursorOut(event: MouseEvent): void {
        this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);

    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    public checkWaitingAnimState(message: string): void {
    }

    public updatePosition(): void {

        if (this.disp && this.disp.stage) {
            this.disp.scaleX = this.disp.scaleY = MathBase.min((this.disp.stage.stageHeight / 600), (this.disp.stage.stageWidth / 800));
            this.disp.x = this.disp.stage.stageWidth / 2; // keep the position in center of the game window
            this.disp.y = (600 * this.disp.scaleY) / 2; // keep it at position locked at the center of the game area
        }
    }
    protected onTutorialEvent(event: Poker2TutorialEvent): void {
        switch (this.tutorialController.tutorialState) {
            case BasicTutorialController.TUT_STATE_COMPLETED:
                this.controller.removeEventListener("tutorialstatechange", this.bindFunction(this.onTutorialEvent));
                break;
        }
    }

    protected get tutorialController(): Poker2TutorialController {
        return Poker2TutorialController.getInstance();
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set env(value/*:IEnvironmentGlobals*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicDialog.prototype, "env").set.call(this, value);
    }
}

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import { Poker2TutorialController } from "../../controller/Poker2TutorialController";
import { Poker2LanguageFontManager } from "../Poker2LanguageFontManager";
import { Poker2LayoutManager } from "../Poker2LayoutManager";
